/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAiCatalog = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M23 23H13v-8h10zm-8-2h2v-4h-2zm4 0h2v-4h-2z" />
        <path d="M12 2a8 8 0 0 1 7.936 7H22v2h-2.064a7.95 7.95 0 0 1-.706 2.429l-1.807-.858A6 6 0 1 0 6 10c0 3.034 2.247 5.596 5.142 6.01L11 18H7.5c-.846 0-1.746.35-2.43.933A3.227 3.227 0 0 0 4.233 20H11v2H2v-1c0-1.464.757-2.723 1.772-3.589a5.96 5.96 0 0 1 2.95-1.353A8.125 8.125 0 0 1 4.064 11H2V9h2.064A8 8 0 0 1 12 2z" />
        <path d="M10 12H8V8h2zm6 0h-2V8h2z" />
      </g>
    </g>
  </Icon>
);
export { SvgAiCatalog as AiCatalog };
